import {Icon} from '@wandb/components';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button,
  Disclosure,
  DisclosurePanel,
  Heading,
} from 'react-aria-components';

import {maybePluralize} from '../../util/uihelpers';

export const WBAgentToolGroup: React.FC<
  React.PropsWithChildren<{
    startIndex: number;
    endIndex: number;
  }>
> = ({startIndex, endIndex, children}) => {
  const count = endIndex - startIndex + 1;
  return (
    <Disclosure defaultExpanded={true} className="group/tool-group">
      <div className="w-full py-8">
        <Heading className="m-0">
          <Button
            slot="trigger"
            className="flex w-full gap-8 items-center bg-transparent px-12 cursor-pointer text-moon-800">
            <span className="inline-flex rotate-0 transition-[rotate] duration-[220ms] group-data-[expanded]/tool-group:rotate-90">
              <Icon icon="chevron-next" size="sm" />
            </span>
            <span className="grow text-left leading-[21px]">
              {maybePluralize(count, 'tool call')}
            </span>
          </Button>
        </Heading>
        <DisclosurePanel className="h-[--disclosure-panel-height] overflow-clip transition-[height] duration-200">
          <div className="mt-8 flex flex-col gap-8 px-12">{children}</div>
        </DisclosurePanel>
      </div>
    </Disclosure>
  );
};
